import { httpsCallable } from "firebase/functions";
import { functions } from "../../shared/libs/firebaseConfig";

const PAGE_SIZE = 25;
const pending = new Map();
export function listPublicReviewCourses(cursor = null) {
  const request = { pageSize: PAGE_SIZE, ...(cursor ? { cursor } : {}) };
  const key = JSON.stringify(request);
  if (pending.has(key)) return pending.get(key);
  const promise = httpsCallable(functions, "listPublicReviewCourses")(request).then(({ data }) => {
    if (!Array.isArray(data?.courses) || data.courses.length > PAGE_SIZE ||
        (data.nextCursor != null && (typeof data.nextCursor !== "string" || data.nextCursor.length > 2048)) ||
        data.courses.some(course => !course || typeof course.courseId !== "string" || !course.courseId ||
          typeof course.courseName !== "string" || !course.courseName)) throw new Error("invalid-public-course-response");
    // Adapt the minimal public DTO to the accepted listing's existing selector.
    return { courses: data.courses.map(({ courseId, courseName }) => ({ id: courseId, name: courseName })), nextCursor: data.nextCursor || null };
  }).finally(() => pending.delete(key));
  pending.set(key, promise);
  return promise;
}
